///// <reference path="../../../../etc/typedefinitions/tsd.d.ts" />
/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.LocationGroups {
    "use strict";

    export class LocationGroupsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public locationGroupDetail: Model.DataDetail;
        public previousBusinessTypeDetail: Model.DataDetail;

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService) {
                super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
                this.baseEndpoint = this.appSettings.API_ENDPOINTS.locationGroups;
                this.sectionTemplatePath = "app/plugins/locationGroups/sectionViews/";
                this.buildCrudSecurityKeysBase(this.securityKeys.DATA_LOCATIONGROUP_TAB_MAIN, true, true);
                this.entityType = 'LocationGroups';
            }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_LOCATIONGROUP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(0, 
                    "MAIN", 
                    "main.html", 
                    true, 
                    false, 
                    this.appSettings.API_ENDPOINTS.locationGroups, 
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.LocationGroupMain,
                    this.appSettings,
                    this.securityKeys.DATA_LOCATIONGROUP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.loadAvailableLocations();
        }

        save(): angular.IPromise<any> {
            let model = this.castModel<Model.LocationGroup>();
            if (model.objectState === Model.ObjectStateEnum.Inactive) {
                this.busyService.stop();
                this.modalService.warning("MESSAGE_CONFIRM_DELETE_LOCATION_GROUP", 0, false, { showCancelButton: true, cancelButtonContentKey: 'LABEL_NO', cancelButtonHotKey: 'MODAL_NO_BUTTON', okButtonHotKey: 'MODAL_YES_BUTTON', okButtonContentKey: 'LABEL_YES' })
                    .then((response: boolean) => {
                        if (response) {
                            return super.save();
                        } else {
                            model.objectState = Model.ObjectStateEnum.Active;
                        }
                    });
            } else {
                return super.save().then((data: any) => {
                    this.loadAvailableLocations();
                });
            }
        }

        savePreviousBusinessTypeDetail(detail): void {
            if (Model.Guard.isSomething(detail))
                this.previousBusinessTypeDetail = detail;
        }

        loadAvailableLocations(): void {
            let locationGroup = this.castModel<Model.LocationGroup>();
            if (Model.Guard.isNothing(locationGroup))
                return;
            let businessTypeDetail = this.selectedSection.model.businessTypeDetail;

            if (Model.Guard.isNothing(this.previousBusinessTypeDetail))
                this.savePreviousBusinessTypeDetail(businessTypeDetail)

            if (Model.Guard.isSomething(businessTypeDetail)) {
                let businessTypeDetailId = Model.Guard.isSomething(businessTypeDetail) && businessTypeDetail.displayName !== 'All Business Type' ? businessTypeDetail.id : null;
                let request = {
                    pageNumber: 0,
                    itemsPerPage: 10000,
                    sortDirection: Model.SortDirection.Ascending,
                    criteria: {
                        businessTypeId: businessTypeDetailId,
                        excludeIdList: _.pluck(locationGroup.selectedLocations, "id")
                    }
                };
                this.dataService.getListPaged('location', request)
                    .then((response: any) => {
                        locationGroup.availableLocations = response;
                        if (locationGroup.selectedLocations.length > 0 && this.previousBusinessTypeDetail.id !== businessTypeDetail.id) {
                            this.modalService.confirmHandler("MESSAGE_MODAL_BUSINESS_TYPE_CHANGE_LOCATION_GROUP", Components.Modal.ModalTranslationModes.Translate)
                                .then((res: boolean) => {
                                    if (res) {
                                        locationGroup.selectedLocations = [];
                                        if (this.previousBusinessTypeDetail.id !== businessTypeDetail.id)
                                            this.savePreviousBusinessTypeDetail(businessTypeDetail);
                                    } else {
                                        this.selectedSection.model.businessTypeDetail = this.previousBusinessTypeDetail;
                                    }
                                    this.loadAvailableLocations();
                                });
                        }
                    });
            }
        }

        addSelected(items): void {
            let location = this.castModel<Model.LocationGroup>();
            if (Model.Guard.isNothing(location))
                return;
            _.forEach(items, (i: any) => {
                if (_.find(location.selectedLocations, (u) => { return u.id === i.id }) === undefined) {
                    location.selectedLocations.push(i);
                    location.availableLocations.splice(location.availableLocations.indexOf(i), 1);
                }
            });
        };

        removeSelected(items): void {
            let location = this.castModel<Model.LocationGroup>();
            if (Model.Guard.isNothing(location))
                return;
            _.forEach(items, (i: any) => {
                if (_.find(location.availableLocations, (u) => { return u.id === i.id }) === undefined) {
                    location.availableLocations.push(i);
                    location.selectedLocations.splice(location.selectedLocations.indexOf(i), 1);
                }
            });
        };

        selectAll(): void {
            let location = this.castModel<Model.LocationGroup>();
            if (Model.Guard.isNothing(location))
                return;
            _.forEach(location.availableLocations, (i) => location.selectedLocations.push(i));
            location.availableLocations.splice(0);
        }

        unselectAllItemCopy(): void {
            let location = this.castModel<Model.LocationGroup>();
            if (Model.Guard.isNothing(location))
                return;
            _.forEach(location.selectedLocations, (i) => location.availableLocations.push(i));
            location.selectedLocations.splice(0);
        };

        delete(): void {
            let model = this.castModel<Model.LocationGroup>();
            if (model.selectedLocations.length > 0) {
                this.deleteConfirmationMessageKey = "MESSAGE_CONFIRM_DELETE_LOCATION_GROUP";
            } 
            super.delete();
        }

        get canCoCopy(): boolean {
            return true;
        }
    }
}